export default "__VITE_ASSET__MjoT2udj__"